import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import { ComplaintItemProps } from './complaint-item.props';
import convertDate from '@utils/time/convert-date';
import Image from '@elements/image';
import { useParams } from 'next/navigation';
import getDictionary from '@dictionaries-client';
import { LocaleTypes } from '@dictionaries-types';

const ComplaintItem = ({ complaintItem }: ComplaintItemProps) => {
  const { lang } = useParams<{ lang : LocaleTypes }>();
  const { dashboard: { complaints } } = getDictionary(lang);

  return (
    <Div className={'w-full flex-col gap-4 p-4 border border-control-300 border-opacity-50 rounded bg-control-50'}>
      <Div className={'w-full justify-between items-center'}>
        <Div className={'gap-1'}>
          <Text typography={'sm'} color={'grey.800'}>{complaints.list.title}</Text>
          <Text typography={'sm'} color={'grey.500'}>{complaintItem?.title}</Text>
        </Div>
        <Text color={complaintItem?.replier_description ? 'success' : 'danger'} typography={'xs'} type={'bold'}>
          {`${complaintItem?.replier_description ? complaints.list.replied : complaints.list.waiting_for_reply}`}
        </Text>
      </Div>
      <Div className={'w-full justify-between items-center'}>
        <Div className={'gap-1'}>
          <Text typography={'sm'} color={'grey.800'}>{complaints.list.order}</Text>
          <Text typography={'sm'} color={'grey.500'}>{complaintItem?.order?.module_id_affix}</Text>
        </Div>
        <Text color={'grey.500'} typography={'sm'}>
          {convertDate(complaintItem?.created_at, 'D MMMM YYYY', lang)}
        </Text>
      </Div>
      <Div className={'w-full flex-col gap-1'}>
        <Text color={'grey.800'} typography={'sm'} align={'start'}>{complaints.list.description}</Text>
        <Text color={'grey.500'} align={'start'} typography={'sm'}>{complaintItem?.description}</Text>
      </Div>
      {complaintItem?.replier_description ? (
        <Div className={'w-full flex-col gap-1'}>
          <Text color={'grey.800'} typography={'sm'} align={'start'}>{complaints.list.replier_description}</Text>
          <Text color={'grey.500'} align={'start'} typography={'sm'}>{complaintItem?.replier_description}</Text>
        </Div>
      ) : null}
      {complaintItem?.image ? (
        <Div className={'w-full border border-control-100 rounded-lg p-2'}>
          <Div className={'relative w-full h-24'}>
            <Image priority={true} className={'object-contain'} fill={true} alt={complaintItem?.title} src={complaintItem?.image}/>
          </Div>
        </Div>
      ) : null}
    </Div>
  );
};

export default ComplaintItem;
